
import { VIcon } from 'vuetify/lib'

export default {
    name: 'Contractors',
    props: {
        value: Array,
        worker: Worker,
    },
    computed: {
        isEmpty(): boolean {
            return this.value.every((item) => !item._isMatch && !item._matchCount)
        },
    },
    mounted() {
        if (!window.Worker) return

        const worker = new Worker(`/contractor-worker.js?v=${process.env.VUE_APP_VERSION}`)
        worker.onmessage = (e) => {
            if (!Array.isArray(e.data.payload)) return

            if (e.data.type === 'contractorFilteredResponse') {
                this.$emit('input', [...e.data.payload])
            }
        }
        this.$emit('update:worker', worker)
    },
    beforeDestroy() {
        this.worker?.terminate()
    },
    render(h) {
        if (this.isEmpty) {
            return h(
                'p',
                {
                    class: ['text-center', 'mt-8'],
                },
                [
                    h(
                        VIcon,
                        {
                            props: {
                                size: '24',
                                left: true,
                            },
                        },
                        'fal fa-building'
                    ),
                    h(
                        'span',
                        {
                            class: ['grey--text', 'text--darken-3'],
                        },
                        [this.$t('fe_contractors["contractorHierarchy.notFound"]').toString()]
                    ),
                ]
            )
        }

        return this.$scopedSlots.default({
            items: this.value,
        })
    },
}
